import { render, staticRenderFns } from "./messagesEdit.vue?vue&type=template&id=cfeaa04c"
import script from "./messagesEdit.vue?vue&type=script&lang=js"
export * from "./messagesEdit.vue?vue&type=script&lang=js"
import style0 from "./messagesEdit.vue?vue&type=style&index=0&id=cfeaa04c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports